import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import moment from 'moment';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';
import Col from 'react-bootstrap/lib/Col';
import Tooltip from 'react-bootstrap/lib/Tooltip';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// Components
import CurrencyConverter from '../CurrencyConverter';
import ListNotFound from '../../routes/listNotFound/ListNotFound';
import NotFound from '../../routes/notFound/NotFound';
import HostClaimModal from '../HostClaimModal/HostClaimModal';

import messages from '../../locale/messages';
import { formatTime } from '../../helpers/formatting';
import { convert } from '../../helpers/currencyConvertion';
import { isRTL } from '../../helpers/formatLocale';
import { generateTime } from './helper';

//Images
import Faq from './question.svg';
import printIcon from '/public/SiteIcons/printer.png';
import arrowIcon from '/public/SiteIcons/paymentArrow.svg';

import cs from '../../components/commonStyle.css'
import s from './Receipt.css';

function tryFixJsonString(str) {
	if (typeof str !== 'string') return str;
	let fixed = str.trim();
	// Remove trailing commas before closing brackets
	fixed = fixed.replace(/,\s*([}\]])/g, '$1');
	// Close open array
	const openArr = (fixed.match(/\[/g) || []).length;
	const closeArr = (fixed.match(/\]/g) || []).length;
	if (openArr > closeArr) {
		fixed += ']'.repeat(openArr - closeArr);
	}
	// Close open object
	const openObj = (fixed.match(/{/g) || []).length;
	const closeObj = (fixed.match(/}/g) || []).length;
	if (openObj > closeObj) {
		fixed += '}'.repeat(openObj - closeObj);
	}
	return fixed;
}

class PaymentReceipt extends React.Component {

	static propTypes = {
		formatMessage: PropTypes.any,
		siteName: PropTypes.string.isRequired,
		data: PropTypes.shape({
			id: PropTypes.number.isRequired,
			listId: PropTypes.number.isRequired,
			checkIn: PropTypes.string.isRequired,
			checkOut: PropTypes.string.isRequired,
			basePrice: PropTypes.number.isRequired,
			delivery: PropTypes.number.isRequired,
			total: PropTypes.number.isRequired,
			discount: PropTypes.number.isRequired,
			discountType: PropTypes.string,
			guestServiceFee: PropTypes.number.isRequired,
			currency: PropTypes.string.isRequired,
			confirmationCode: PropTypes.number.isRequired,
			createdAt: PropTypes.string.isRequired,
			updatedAt: PropTypes.string.isRequired,
			listData: PropTypes.shape({
				id: PropTypes.number.isRequired,
				title: PropTypes.string.isRequired,
				street: PropTypes.string.isRequired,
				city: PropTypes.string.isRequired,
				state: PropTypes.string.isRequired,
				country: PropTypes.string.isRequired,
				zipcode: PropTypes.string.isRequired,
				listingData: PropTypes.shape({
					checkInStart: PropTypes.string.isRequired,
					checkInEnd: PropTypes.string.isRequired
				}),
				settingsData: PropTypes.arrayOf(PropTypes.shape({
					id: PropTypes.number,
					listsettings: PropTypes.shape({
						itemName: PropTypes.string.isRequired
					})
				}))
			}),
			hostData: PropTypes.shape({
				displayName: PropTypes.string.isRequired,
			}),
			guestData: PropTypes.shape({
				displayName: PropTypes.string.isRequired,
			}),
			bookingSpecialPricing: PropTypes.array,
		})
	};

	static defaultProps = {
		data: null
	};

	state = { showModal: false };

	print() {
		window.print()
	}

	changeModalState = (status = false) => this.setState({ showModal: status });

	render() {
		const { data, siteName, userId } = this.props;
		const { formatMessage } = this.props.intl;
		const { intl: { locale } } = this.props;

		function LinkWithTooltip({ id, children, href, tooltip }) {
			return (
				<OverlayTrigger
					overlay={<Tooltip className={s.tooltip} id={id}>{tooltip}</Tooltip>}
					placement="top"
					delayShow={300}
					delayHide={150}
				>
					{children}
				</OverlayTrigger>
			);
		}

		if (!data) {
			return <> <FormattedMessage {...messages.errorMessage} /> </>;
		} else if (!data.listData) {
			return <ListNotFound />
		} else if (data.paymentState !== "completed") {
			return <NotFound />
		} else {
			const { data, data: { id, listId, checkIn, checkOut, confirmationCode, createdAt, updatedAt, hostId, startTime, endTime, listTitle, dayDifference } } = this.props;
			const { data: { basePrice, delivery, total, discount, discountType, guestServiceFee, processingFee, currency, hostServiceFee, hostServiceFeeType, hostServiceFeeValue, isHourly, claimRefundedAt, megasoftVoucher, cameFromFeatured, featuredCommissionRate, featuredCommissionAmount } } = this.props;
			const { data: { hostData, guestData, licenseNumber, firstName, middleName, dateOfBirth, countryLabel, claimTransaction } } = this.props;
			const { data: { listData: { title, street, city, state, country, zipcode } } } = this.props;
			const { data: { listData: { listingData: { checkInStart, checkInEnd, hourlyPrice } } } } = this.props;
			const { data: { listData: { settingsData } }, refetch, currencyRates } = this.props;
			const { data: { bookingSpecialPricing, securityDeposit, claimRefund, claimAmount, claimStatus, claimImages, claimReason, cancellationDetails, reservationState, claimPayout, reservationAddons } } = this.props;
			const { showModal } = this.state;

			let roomType, createdDate, updatedDate, birthDate, claimRefundedDate, checkInDate, checkOutDate, isAverage = 0, subTotal, userType;
			let momentStartDate, momentEndDate, dayPrice = 0, checkInTime, checkOutTime, isSpecialPricingAssinged, modalInitialValues = {};
			let isDayTotal = 0, formattedStartTime, formattedEndTime, claimPaidAmount = claimTransaction?.amount, claimPaidCurrency = claimTransaction?.currency;
			roomType = settingsData[0].listsettings.itemName;
			createdDate = createdAt ? moment(createdAt).format('ddd, MMM DD, YYYY ') : '';
			updatedDate = updatedAt ? moment(updatedAt).format('ddd, MMM DD, YYYY ') : '';
			birthDate = dateOfBirth ? moment(dateOfBirth, 'MM-DD-YYYY').format('MM/DD/YYYY') : '';
			claimRefundedDate = claimRefundedAt ? moment(claimRefundedAt).format('ddd, MMM Do, YYYY ') : '';
			checkInDate = checkIn ? moment(checkIn).utc().format('ddd, MMM DD, YYYY ') : '';
			checkOutDate = checkOut ? moment(checkOut).utc().format('ddd, MMM DD, YYYY ') : '';
			isSpecialPricingAssinged = (bookingSpecialPricing && bookingSpecialPricing.length > 0) ? true : false;
			modalInitialValues.securityDeposit = convert(currencyRates.base, currencyRates.rates, securityDeposit, currency, currencyRates.to).toFixed(2);

			if (claimStatus && claimStatus != 'pending') {
				modalInitialValues.claimAmount = convert(currencyRates.base, currencyRates.rates, claimAmount, currency, currencyRates.to).toFixed(2);
				modalInitialValues.claimReason = claimReason;
				modalInitialValues.claimImages = claimImages;
			}

			if (isSpecialPricingAssinged) {
				bookingSpecialPricing && bookingSpecialPricing.map((item, index) => {
					dayPrice = dayPrice + Number(item.isSpecialPrice);
				});
			} else if (isHourly) {
				// For hourly bookings, use hourlyPrice × hours
				const hourDiff = endTime - startTime;
				const hours = hourDiff >= 0 ? hourDiff : (24 - startTime + endTime);
				dayPrice = (hourlyPrice || basePrice) * hours;
			} else {
				dayPrice = basePrice * dayDifference;
			}

			if (checkInStart === 'Flexible') {
				checkInTime = formatMessage(messages.flexibleCheckIn);
			} else {
				checkInTime = generateTime(checkInStart);
			}

			if (checkInEnd === 'Flexible') {
				checkOutTime = formatMessage(messages.flexibleCheckOut);
			} else {
				checkOutTime = generateTime(checkInEnd);
			}

			// Use stored processingFee from props, or default to 0
			const finalProcessingFee = processingFee || 0;
			// Calculate host's base earnings from the actual price (not from total which may include fees)
			// Host earnings = priceForDays + delivery - discount - hostServiceFee - featuredCommission
			const hostBaseEarnings = (dayPrice + delivery) - discount;

			// Calculate add-ons total FIRST (needed for service fee calculation)
			let addonsTotal = 0;
			if (reservationAddons && reservationAddons.length > 0) {
				addonsTotal = reservationAddons.reduce((sum, addon) => sum + (addon.totalPrice || 0), 0);
			}

			// ═══════════════════════════════════════════════════════════════════
			// RECALCULATE hostServiceFee INCLUDING addons
			// Service fee is calculated on (basePrice + addons) as per user requirement
			// ═══════════════════════════════════════════════════════════════════
			const hostEarningsWithAddons = hostBaseEarnings + addonsTotal;
			let calculatedHostServiceFee = hostServiceFee;
			if (hostServiceFeeType && hostServiceFeeValue) {
				if (hostServiceFeeType === 'percentage') {
					// Calculate percentage on base earnings + addons
					calculatedHostServiceFee = hostEarningsWithAddons * (hostServiceFeeValue / 100);
				} else {
					calculatedHostServiceFee = hostServiceFeeValue;
				}
			}

			// IMPORTANT: Detect if addons are already included in 'total'
			// For Stripe reservations: total = basePrice + addons
			const addonsAlreadyInTotal = addonsTotal > 0 && Math.abs(total - (basePrice + addonsTotal)) < 1;

			if (userId === hostId) {
				userType = 'owner';
				// Host earnings: (base + addons) - serviceFee - featuredCommission
				subTotal = hostEarningsWithAddons - calculatedHostServiceFee;
				// Deduct Featured commission if applicable
				if (cameFromFeatured && featuredCommissionAmount > 0) {
					subTotal = subTotal - featuredCommissionAmount;
				}
			} else {
				userType = 'renter';
				// For guest view: total from API already includes EVERYTHING (base + addons + fees + securityDeposit).
				// We should NOT reconstruct it manually to avoid double-counting.
				subTotal = total;
			}

			isAverage = Number(dayPrice) / Number(dayDifference);
			isDayTotal = isAverage.toFixed(2) * dayDifference;
			dayPrice = isDayTotal;

			formattedStartTime = formatTime(startTime);
			formattedEndTime = formatTime(endTime);

			let checkOutDifference = 0;
			if (reservationState == 'completed') checkOutDifference = moment().diff(moment(checkOut), 'hour', true);
			if (cancellationDetails && reservationState == 'cancelled') {
				let todayDiff = moment().diff(moment(checkIn), 'hour', true);
				if (todayDiff > 0) checkOutDifference = moment().diff(moment(cancellationDetails.createdAt), 'hour', true);
			}

			let showSecurityDeposit = userType === "owner" && securityDeposit <= 0 ? false : true;

			const hourDiff = endTime - startTime;
			const hourlyDifference = hourDiff >= 0 ? hourDiff : (24 - startTime + endTime);
			return (
				<Grid fluid className={cx(s.container, cs.spaceTop4)}>
					<Row>
						<Col lg={12} md={12} sm={12} xs={12}>
							{showModal && <HostClaimModal
								refetchData={refetch}
								claimed={Boolean(claimStatus && claimStatus != 'pending')}
								reservationId={id}
								show={showModal}
								currency={currency}
								changeModalState={this.changeModalState}
								initialValues={modalInitialValues}
							/>}
							<div className={cx(s.diplayFlex, cs.spaceTop5, s.fullWidthMobile)}>
								<div className={cs.spaceBottom4}>
									<h2 className={cx(cs.commonTitleText, cs.paddingBottom1, cs.fontWeightBold)}><FormattedMessage {...messages.customerReceipt} /></h2>
									<h4 className={cx(cs.commonContentText, cs.fontWeightNormal)}><FormattedMessage {...messages.receipt} />: #{id}</h4>
								</div>
								<a className={cx(cs.btnPrimary, cs.btnlarge, "hidden-print", cs.displayInlineBlock, cs.spaceBottom4)} onClick={this.print}>
									<img src={printIcon} className={'commonIconSpace'} />
									<FormattedMessage {...messages.print} />
								</a>
							</div>
							<div className={s.receiptGrid}>
								<div className={cx(cs.spaceBottom4, { [s.directionRTLPrint]: isRTL(locale) })}>
									<div className={s.mainSection}>
										<h6 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom2)}><FormattedMessage {...messages.bookedBy} />: {guestData.firstName} </h6>
										<h4 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom2)}><span><FormattedMessage {...messages.confirmationCode} />:</span> <span>#{confirmationCode}</span></h4>
										<h5 className={cx(cs.commonMediumText, cs.fontWeightNormal)}>{createdDate}</h5>
										<hr className={cx(s.listingHorizoltalLine, cs.spaceBottom3, cs.spaceTop3)} />
										<>
											<h3 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom3)}><FormattedMessage {...messages.vehicleDetails} /></h3>
											<div className={s.displayGridDetails}>
												<>
													<h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom8)}><FormattedMessage {...messages.ownersName} /></h4>
													<a href={'/users/show/' + hostData.profileId} target={"_blank"} className={cx(cs.siteLinkColor, cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom2, s.displayInline, "hidden-print")}>
														{hostData.firstName}
													</a>
													<span className={cx(cs.siteLinkColor, cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom2, s.displayInline, 'printText')}>{hostData.firstName}</span>
												</>
												<>
													<h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom8)}><FormattedMessage {...messages.whatKindOfPlace} /></h4>
													<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom3)}>{roomType}</p>
												</>
											</div>
											<h5 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom8)}><FormattedMessage {...messages.location} /></h5>
											<a href={'/boats/' + listId} target={"_blank"} className={cx(cs.siteLinkColor, cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom2, s.displayInline, "hidden-print")}>{listTitle || title}</a>
											<span className={cx(cs.siteLinkColor, cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom2, s.displayInline, 'printText')}>{listTitle || title}</span>
											<p className={cx(cs.commonMediumText, cs.fontWeightNormal)}>
												<span>{street}</span>
												<span>{city}, {state} {zipcode}</span>{' '}
												<span>{country}</span>
											</p>
										</>
										<hr className={cx(s.listingHorizoltalLine, cs.spaceBottom3, cs.spaceTop3)} />
										<>
											<h4 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom3)}><FormattedMessage {...messages.tripDetails} /></h4>
											<div className={s.displayGridDate}>
												<h5 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom2)}><FormattedMessage {...messages.checkIn} /></h5>
												<span></span>
												<h5 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom2)}><FormattedMessage {...messages.checkOut} /></h5>
											</div>
											<div className={s.displayGridDate}>
												<div className={s.paddingRight}>
													<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1)}>{checkInDate} </p>
													<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom3)}>{formattedStartTime}</p>
												</div>
												<span className={s.tripArrowIconSec}>
													<img src={arrowIcon} className={cx(cs.dateArrowMargin, 'commonDateArrowRTLRotate', 'printMobileArrow')} />
												</span>
												<div className={s.paddingRight}>
													<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1)}>{checkOutDate}</p>
													<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom3)}>{formattedEndTime}</p>
												</div>
											</div>
											<div className={s.displayGridDetails}>

												<>
													<h6 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom2)}><FormattedMessage {...messages.travelDestination} /></h6>
													<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom3)}>{city}</p>
												</>
											</div>
											<h4 className={cx(cs.commonContentText, cs.fontWeightBold, cs.paddingBottom2)}><FormattedMessage {...messages.renterInfo} /></h4>
											<div className={s.displayGridDetails}>
												<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1, cs.dFlexWrapAlignStart, s.colSpaceRight, 'colReceiptSpaceLeftRTL')}>
													<span className={cx(cs.fontWeightMedium, s.infoDetailsPadding, 'receiptInfoDetailSpaceRTL')}><FormattedMessage {...messages.name} />:</span>
													<span>{firstName} {middleName && <>{middleName}</>}</span>
												</p>
												<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1, cs.dFlexWrapAlignStart)}>
													<span className={cx(cs.fontWeightMedium, s.infoDetailsPadding, 'receiptInfoDetailSpaceRTL')}><FormattedMessage {...messages.dob} />:</span>
													<span>{birthDate}</span>
												</p>
												<p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1, cs.dFlexWrapAlignStart, s.colSpaceRight, 'colReceiptSpaceLeftRTL')}>
													<span className={cx(cs.fontWeightMedium, s.infoDetailsPadding, 'receiptInfoDetailSpaceRTL')}><FormattedMessage {...messages.licenseNumber} />:</span>
													<span>{licenseNumber}</span>
												</p>
												{countryLabel && <p className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.paddingBottom1, cs.dFlexWrapAlignStart)}>
													<span className={cx(cs.fontWeightMedium, s.infoDetailsPadding, 'receiptInfoDetailSpaceRTL')}><FormattedMessage {...messages.country} />:</span>
													<span>{countryLabel}</span>
												</p>}
											</div>
										</>
									</div>
								</div>
								<div className={cx({ [s.directionRTLPrint]: isRTL(locale) }, s.positionStickey)}>
									<div className={cx(s.mainSection, cs.spaceBottom4, s.bgColor, 'bgColorPrint')}>
										<h4 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom3)}><FormattedMessage {...messages.billing} /></h4>
										<div className={cx(s.diplayFlex, s.flexBillingSection)}>
											<div className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.positionRelative, s.splitUpColOneWidth)}>
												<div className={cx(s.specialPriceIcon, "hidden-print")}>
													{
														isSpecialPricingAssinged &&
														<span className={s.iconSection}>
															<img src={Faq} className={cx(s.faqImage, 'faqImageRTL')} />
														</span>
													}
													<div className={cx(s.toolTip, s.toolTipRelativeSection, 'toolTipRelativeSectionRTL')}>
														<FormattedMessage {...messages.averageRate} />
													</div>
												</div>
												<span className={cx('directionLtr', cs.displayInlineBlock)}>
													<CurrencyConverter
														amount={isHourly ? (hourlyPrice || basePrice) : basePrice}
														from={currency}
													/>
													{' x'}
													{
														isHourly ?
															<>
																{hourlyDifference} {hourlyDifference > 1 ? "Hours" : "Hour"}
															</>
															:
															<>
																{dayDifference} {dayDifference > 1 ? formatMessage(messages.nights) : formatMessage(messages.night)}
															</>

													}
												</span>
											</div>
											<h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
												{
													isHourly ?
														<>
															<CurrencyConverter
																amount={(hourlyPrice || basePrice) * hourlyDifference}
																from={currency}
															/>
														</>

														:
														<>
															<CurrencyConverter
																amount={dayPrice}
																from={currency}
															/>
														</>
												}
											</h6>
										</div>
										{
											delivery > 0 && <>
												<hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
												<div className={cx(s.diplayFlex, s.flexBillingSection)}>
													<h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.splitUpColOneWidth)}>
														<FormattedMessage {...messages.cleaningFee} />
													</h5>
													<h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
														<CurrencyConverter
															amount={delivery}
															from={currency}
														/>
													</h6>
												</div>
											</>
										}
										{
											discount > 0 && <>
												<hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
												<div className={cx(s.diplayFlex, s.flexBillingSection)}>
													<h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.splitUpColOneWidth)}>{discountType}</h5>
													<h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, s.discountColor, 'textAlignLeftRTL')}>{"-"}
														<CurrencyConverter
															amount={discount}
															from={currency}
														/>
													</h6>
												</div>
											</>
										}
										{
											userType === 'renter' && guestServiceFee > 0 && <>
												<hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
												<div className={cx(s.diplayFlex, s.flexBillingSection)}>
													<h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.splitUpColOneWidth)}><FormattedMessage {...messages.serviceFee} /></h5>
													<h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
														<CurrencyConverter
															amount={guestServiceFee}
															from={currency}
														/>
													</h6>
												</div>
											</>
										}
										{
											userType === 'renter' && (total + guestServiceFee) > 0 && <>
												<hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
												<div className={cx(s.diplayFlex, s.flexBillingSection)}>
													<h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.splitUpColOneWidth)}><FormattedMessage {...messages.processingFee} /></h5>
													<h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
														<CurrencyConverter
															amount={(total + guestServiceFee) * 0.03}
															from={currency}
														/>
													</h6>
												</div>
											</>
										}
										{
											userType === 'owner' && calculatedHostServiceFee > 0 && <>
												<hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
												<div className={cx(s.diplayFlex, s.flexBillingSection)}>
													<h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.splitUpColOneWidth)}><FormattedMessage {...messages.serviceFee} /></h5>
													<h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
														{'-'}<CurrencyConverter
															amount={calculatedHostServiceFee}
															from={currency}
														/>
													</h6>
												</div>
											</>
										}
										{
											userType === 'owner' && cameFromFeatured && featuredCommissionAmount > 0 && <>
												<hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
												<div className={cx(s.diplayFlex, s.flexBillingSection)}>
													<h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.splitUpColOneWidth)} style={{ color: '#D97706' }}>
														Comisión Featured ({featuredCommissionRate}%)
													</h5>
													<h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')} style={{ color: '#D97706' }}>
														{'-'}<CurrencyConverter
															amount={featuredCommissionAmount}
															from={currency}
														/>
													</h6>
												</div>
											</>
										}
										{
											userType === 'renter' && securityDeposit > 0 && <>
												<hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
												<div className={cx(s.diplayFlex, s.flexBillingSection)}>
													<h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.splitUpColOneWidth)}>
														<FormattedMessage {...messages.securityDeposit} />
													</h5>
													<h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
														<CurrencyConverter
															amount={securityDeposit}
															from={currency}
														/>
													</h6>
												</div>
											</>
										}
										{/* Reservation Add-ons - show for both renter and owner */}
										{reservationAddons && reservationAddons.length > 0 && reservationAddons.map((addon, index) => (
											<React.Fragment key={addon.id || index}>
												<hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
												<div className={cx(s.diplayFlex, s.flexBillingSection)}>
													<h5 className={cx(cs.commonMediumText, cs.fontWeightNormal, s.splitUpColOneWidth)}>
														{addon.name} {addon.quantity > 1 ? `(x${addon.quantity})` : ''}
													</h5>
													<h6 className={cx(cs.commonMediumText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
														<CurrencyConverter
															amount={addon.totalPrice}
															from={currency}
														/>
													</h6>
												</div>
											</React.Fragment>
										))}
										{userType === 'renter' && data.reservationState != 'cancelled' && <>
											<hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
											<div className={cx(s.diplayFlex, s.flexBillingSection)}>
												<h5 className={cx(cs.commonMediumText, cs.fontWeightBold, s.splitUpColOneWidth)}><FormattedMessage {...messages.total} /></h5>
												<h6 className={cx(cs.commonMediumText, cs.fontWeightBold, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
													<CurrencyConverter
														amount={subTotal}
														from={currency}
													/>
												</h6>
											</div>
										</>}
										{userType === 'owner' && <>
											<hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
											<div className={cx(s.diplayFlex, s.flexBillingSection)}>
												<h5 className={cx(cs.commonMediumText, cs.fontWeightBold, s.splitUpColOneWidth)}>
													{reservationState == 'completed' ? <FormattedMessage {...messages.earnings} /> :

														<FormattedMessage {...messages.estimatedEarnings} />
													}
												</h5>
												<h6 className={cx(cs.commonMediumText, cs.fontWeightBold, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
													<CurrencyConverter
														amount={subTotal > 0 ? subTotal : 0}
														from={currency}
													/>
												</h6>
											</div>
										</>
										}
										{userType === 'owner' && reservationState == 'cancelled' && cancellationDetails && <>
											<hr className={cx(cs.listingHorizoltalLine, cs.spaceBottom2, cs.spaceTop2)} />
											<div className={cx(s.diplayFlex, s.flexBillingSection)}>
												<h5 className={cx(cs.commonMediumText, cs.fontWeightBold, s.splitUpColOneWidth)}><FormattedMessage {...messages.actualEarnings} /></h5>
												<h6 className={cx(cs.commonMediumText, cs.fontWeightBold, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
													<CurrencyConverter
														amount={cancellationDetails.payoutToHost}
														from={currency}
													/>
												</h6>
											</div>
										</>}
									</div>
									{showSecurityDeposit && <div className={cx(s.mainSection, cs.spaceBottom4)}>
										{userType === 'renter' && <h4 className={cx(cs.commonTotalText, cs.fontWeightBold, cs.paddingBottom3)}><FormattedMessage {...messages.payment} /></h4>}
										{
											userType === 'renter' &&
											<>
												<div className={cx(s.diplayFlex, cs.paddingBottom2)}>
													<h5 className={cx(cs.commonContentText, cs.fontWeightNormal, s.splitUpColOneWidth)}><FormattedMessage {...messages.paid} /></h5>
													<h6 className={cx(cs.commonContentText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
														<CurrencyConverter
															amount={subTotal}
															from={currency}
														/>
													</h6>
												</div>
												<p className={cx(cs.commonContentText, cs.fontWeightNormal)}>{updatedDate}</p>
											</>
										}
										{
											userType === 'owner' && securityDeposit > 0 &&
											<>
												<div className={cx(s.diplayFlex)}>
													<h5 className={cx(cs.commonContentText, cs.fontWeightNormal, s.splitUpColOneWidth)}><FormattedMessage {...messages.securityDepositByRenter} /></h5>
													<p className={cx(cs.commonContentText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
														<CurrencyConverter
															amount={securityDeposit}
															from={currency}
														/>
													</p>
												</div>

												{claimStatus == 'pending' && checkOutDifference > 0 && checkOutDifference < 24 && <div className={cs.spaceTop8}><span><a className={cx(cs.siteLinkColor, cs.curserPointer, cs.commonContentText, cs.fontWeightMedium)} onClick={() => this.changeModalState(true)}>{' ('}<FormattedMessage {...messages.claimDamage} />{')'}</a></span></div>}
												{claimAmount > 0 && <div className={cs.spaceTop8}><span><a className={cx(cs.siteLinkColor, cs.curserPointer, cs.commonContentText, cs.fontWeightMedium)} onClick={() => this.changeModalState(true)}>{' ('}<FormattedMessage {...messages.claimDetails} />{')'}</a></span></div>}

											</>
										}
										{
											userType === 'renter' && (['approved', 'fullyRefunded'].includes(claimStatus)) &&
											<>
												<div className={cx(s.diplayFlex, cs.spaceTop4)}>
													<h5 className={cx(cs.commonContentText, cs.fontWeightNormal, s.splitUpColOneWidth)}>
														<FormattedMessage {...messages.refundedSecurityDeposit} />
													</h5>
													<h6 className={cx(cs.commonContentText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
														<CurrencyConverter
															amount={claimRefund}
															from={currency}
														/>
													</h6>
												</div>
												<p className={cx(cs.commonContentText, cs.fontWeightNormal, cs.spaceTop8)}>{claimRefundedDate}</p>

												{securityDeposit > 0 && claimAmount > 0 && <div className={cs.spaceTop8}><a className={cx(cs.siteLinkColor, cs.curserPointer, cs.commonContentText, cs.fontWeightMedium)} onClick={() => this.changeModalState(true)}>{' ('}<FormattedMessage {...messages.claimDetails} />{')'}</a></div>}

											</>
										}
										{
											userType === 'owner' && claimStatus == 'approved' && claimPayout > 0 && <>
												<div className={cx(s.diplayFlex, cs.spaceTop4)}>
													<h5 className={cx(cs.commonContentText, cs.fontWeightNormal, s.splitUpColOneWidth)}>
														<FormattedMessage {...messages.claimPaidToHost} />
													</h5>
													<h6 className={cx(cs.commonContentText, cs.fontWeightNormal, cs.textAlignRight, s.splitUpColTwoWidth, 'textAlignLeftRTL')}>
														<CurrencyConverter
															amount={claimPayout}
															from={currency}
														/>
													</h6>
												</div>
												<p className={cx(cs.commonContentText, cs.fontWeightNormal, cs.spaceTop8)}>{claimRefundedDate}</p>
											</>
										}
									</div>}
								</div>
							</div>
							{/* ═══════════════════════════════════════════════════════════════════════ */}
							{/* PREMIUM DIGITAL VOUCHER - Ticket Style                                    */}
							{/* ═══════════════════════════════════════════════════════════════════════ */}
							{megasoftVoucher && (() => {
								try {
									let parsed;
									try {
										parsed = typeof megasoftVoucher === 'string' ? JSON.parse(megasoftVoucher) : megasoftVoucher;
									} catch (e) {
										const fixed = tryFixJsonString(megasoftVoucher);
										try {
											parsed = JSON.parse(fixed);
										} catch (e2) {
											parsed = null;
										}
									}

									// Premium Voucher Styles
									const voucherStyles = {
										container: { background: '#FFFFFF', borderRadius: '20px', boxShadow: '0 20px 50px rgba(0, 0, 0, 0.12)', margin: '24px 0', overflow: 'hidden', maxWidth: '440px' },
										header: { background: 'linear-gradient(135deg, #10B981 0%, #059669 100%)', padding: '32px 24px', textAlign: 'center', color: 'white' },
										checkIcon: { width: '72px', height: '72px', background: 'rgba(255, 255, 255, 0.2)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px', fontSize: '36px' },
										body: { padding: '24px' },
										dataRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px dashed #E5E7EB' },
										dataLabel: { fontSize: '14px', color: '#6B7280' },
										dataValue: { fontSize: '14px', fontWeight: '600', color: '#1F2937', fontFamily: "'SF Mono', 'Roboto Mono', 'Courier New', monospace" },
										amountBox: { background: 'linear-gradient(135deg, #F3F4F6 0%, #E5E7EB 100%)', borderRadius: '12px', padding: '20px', textAlign: 'center', margin: '20px 0' },
										referenceBox: { background: '#F9FAFB', border: '2px dashed #D1D5DB', borderRadius: '12px', padding: '16px', textAlign: 'center', margin: '20px 0' },
										footer: { background: '#F9FAFB', padding: '16px 24px', textAlign: 'center', borderTop: '1px solid #E5E7EB', fontSize: '12px', color: '#9CA3AF' }
									};

									if (typeof parsed === 'object' && parsed !== null) {
										const amount = parsed.monto || parsed.amount || parsed.TotalBs;
										const reference = parsed.referencia || parsed.control || parsed.authid || parsed.factura;
										const date = parsed.fecha || new Date().toLocaleDateString('es-VE');
										const time = parsed.hora || new Date().toLocaleTimeString('es-VE');

										const fieldLabels = {
											control: 'Control', codigo: 'Código', descripcion: 'Descripción', vtid: 'VTID', seqnum: 'Secuencia',
											authid: 'Auth ID', authname: 'Autorización', factura: 'Factura', referencia: 'Referencia',
											terminal: 'Terminal', lote: 'Lote', rifba: 'RIF Banco', monto: 'Monto', fecha: 'Fecha', hora: 'Hora',
											cuenta: 'Cuenta', pan: 'PAN', aprobacion: 'Aprobación', status: 'Estado', tarjeta: 'Tarjeta',
											banco: 'Banco', cliente: 'Cliente', telefono: 'Teléfono', email: 'Email', cedula: 'Cédula',
											tipo: 'Tipo', moneda: 'Moneda', bancoDestino: 'Banco Destino', bancoOrigen: 'Banco Origen',
											cuentaDestino: 'Cuenta Destino', cuentaOrigen: 'Cuenta Origen', comercio: 'Comercio',
											pos: 'POS', c2p: 'C2P', p2c: 'P2C', zelle: 'Zelle', zelleRef: 'Zelle Ref', zelleName: 'Zelle Nombre'
										};
										const highlightedFields = ['monto', 'amount', 'TotalBs', 'referencia', 'control', 'authid', 'factura'];

										return (
											<div style={voucherStyles.container}>
												<div style={voucherStyles.header}>
													<div style={voucherStyles.checkIcon}>✓</div>
													<h3 style={{ fontSize: '24px', fontWeight: '700', margin: '0 0 4px 0' }}>¡Pago Aprobado!</h3>
													<p style={{ fontSize: '14px', opacity: '0.9', margin: '0' }}>Tu transacción fue procesada exitosamente</p>
												</div>
												<div style={{ height: '20px', background: 'radial-gradient(circle at 10px 0, #FFFFFF 10px, transparent 10px) repeat-x', backgroundSize: '20px 20px', marginTop: '-10px' }}></div>
												<div style={voucherStyles.body}>
													{amount && (
														<div style={voucherStyles.amountBox}>
															<div style={{ fontSize: '12px', color: '#6B7280', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '4px' }}>Monto Total</div>
															<div style={{ fontSize: '32px', fontWeight: '700', color: '#1F2937', fontFamily: "'SF Mono', 'Roboto Mono', 'Courier New', monospace" }}>
																Bs {Number(amount).toLocaleString('es-VE', { minimumFractionDigits: 2 })}
															</div>
														</div>
													)}
													{reference && (
														<div style={voucherStyles.referenceBox}>
															<div style={{ fontSize: '11px', color: '#6B7280', textTransform: 'uppercase', letterSpacing: '1px', marginBottom: '8px' }}>Número de Referencia</div>
															<div style={{ fontSize: '20px', fontWeight: '700', color: '#1F2937', fontFamily: "'SF Mono', 'Roboto Mono', 'Courier New', monospace", letterSpacing: '2px' }}>{reference}</div>
														</div>
													)}
													<div style={{ marginTop: '16px' }}>
														{Object.keys(parsed).map((key, index, arr) => {
															if (key === 'voucher' || highlightedFields.includes(key)) return null;
															let value = parsed[key];
															if (value === null || value === undefined || value === '') return null;
															if (Array.isArray(value)) value = value.join(', ');
															if (typeof value === 'object') value = JSON.stringify(value);
															const label = fieldLabels[key] || key.charAt(0).toUpperCase() + key.slice(1);
															const isStatus = key === 'descripcion' || key === 'aprobacion' || key === 'status' || key === 'codigo';
															return (
																<div key={key} style={{ ...voucherStyles.dataRow }}>
																	<span style={voucherStyles.dataLabel}>{label}</span>
																	<span style={{ ...voucherStyles.dataValue, color: isStatus ? '#10B981' : '#1F2937', maxWidth: '200px', textAlign: 'right', wordBreak: 'break-word' }}>{String(value)}</span>
																</div>
															);
														})}
														<div style={{ ...voucherStyles.dataRow, borderBottom: 'none', marginTop: '8px', paddingTop: '16px', borderTop: '1px solid #E5E7EB' }}>
															<span style={voucherStyles.dataLabel}>📅 Fecha/Hora</span>
															<span style={voucherStyles.dataValue}>{date} {time}</span>
														</div>
													</div>
												</div>
												<div style={voucherStyles.footer}>
													<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
														<span>🔒</span><span>Procesado por Megasoft</span>
													</div>
												</div>
											</div>
										);
									} else {
										return (
											<div style={{ background: '#FFFFFF', borderRadius: '20px', boxShadow: '0 20px 50px rgba(0, 0, 0, 0.12)', padding: '24px', margin: '24px 0' }}>
												<div style={{ textAlign: 'center', marginBottom: '16px' }}>
													<span style={{ fontSize: '48px' }}>✓</span>
													<h3 style={{ color: '#10B981', margin: '8px 0' }}>Pago Procesado</h3>
												</div>
												<details style={{ background: '#F9FAFB', borderRadius: '8px', padding: '12px' }}>
													<summary style={{ cursor: 'pointer', fontWeight: '600', color: '#5469d4' }}>Ver detalles técnicos</summary>
													<pre style={{ background: '#1F2937', color: '#10B981', borderRadius: '8px', padding: '16px', marginTop: '12px', fontSize: '12px', whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontFamily: "'SF Mono', 'Roboto Mono', 'Courier New', monospace" }}>{megasoftVoucher}</pre>
												</details>
											</div>
										);
									}
								} catch (e) {
									return null;
								}
							})()}
							<p className={cx(cs.commonContentText, cs.fontWeightNormal, cs.paddingBottom2)}>
								{siteName} <FormattedMessage {...messages.receiptInfo1} />{' '}
								<FormattedMessage {...messages.receiptInfo2} /> {siteName}.{' '}
								<FormattedMessage {...messages.receiptInfo3} /> {siteName}.
							</p>
						</Col>
					</Row>
				</Grid >
			);
		}
	}
}

const mapState = (state) => ({
	siteName: state?.siteSettings?.data?.siteName,
	userId: state?.account?.data?.userId,
	currencyRates: state?.currency
});

const mapDispatch = {};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(PaymentReceipt)));